<template lang="pug">
  .product-filters-bar.bg-white(
    v-if="Object.keys(filters).length > 0" data-slideout-ignore
  )
    .filter-box__container-loading(v-if="loading.isRefreshing")
      font-awesome-icon(:icon=['far', 'circle-notch'] spin)
    vue-perfect-scrollbar.filter-box__container.d-none.d-md-flex.flex-row
      .filter-box.mb-3.mb-lg-0(v-for="(value, key) in filters" v-if="value.values.length > 0")
        label.filter-box__title {{ getSpecLabelByKey(key) }}
        vue-perfect-scrollbar.filter-box__values
          .filter-box__value(
            v-for="value in value.values"
            @click="onFilterSelected(key, value)"
            v-bind:class="{'filter-box__value--selected': isFilterSelected(key, value)}"
            :disabled="!value.visible"
          ) {{ value.label }}
        a.filter-box__clear(v-if="selected[key] && selected[key].length > 0" @click="onClearFilters(key)") Clear

    div.filter-box__container.d-flex.d-md-none.flex-row
      .filter-box.mb-3.mb-lg-0(v-for="(value, key) in filters" v-if="value.values.length > 0")
        label.filter-box__title {{ getSpecLabelByKey(key) }}
        vue-perfect-scrollbar.filter-box__values
          .filter-box__value(
            v-for="value in value.values"
            @click="onFilterSelected(key, value)"
            v-bind:class="{'filter-box__value--selected': isFilterSelected(key, value)}"
            :disabled="!value.visible"
          ) {{ value.label }}
        a.filter-box__clear(v-if="selected[key] && selected[key].length > 0" @click="onClearFilters(key)") Clear
    .product-filters-bar__actions
      button.btn.btn-secondary.btn-sm.mr-2(@click="onApplyFilters") Apply Filters
      button.btn.btn-secondary.btn-sm.btn-outline(@click="onClearAll") Reset
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
  import {RepositoryFactory} from "../../../repositoryFactory";
  import ProductCategorySpecs from "./ProductCategorySpecs";
  import notify from "../../../components/notify";
  import EventBus from "../../../eventBus";

  const ProductRepository = RepositoryFactory.get('product');
  const ProductCategoryRepository = RepositoryFactory.get('productCategory');

  const CancelToken = window.axios.CancelToken;
  const AxiosSource = CancelToken.source();

  export default {
    components: {
      VuePerfectScrollbar
    },
    props: {
      dataFilters: {
        type: Object,
        default: () => {
        },
      }
    },
    data() {
      return {
        touchDevice: ('ontouchstart' in window || navigator.msMaxTouchPoints) || false,
        loading: {
          isRefreshing: false,
        },
        scopes: {
          ...this.dataFilters,
          ...{
            query: this.$route.params.query || false
          }
        },
        filters: {},
        selected: {},
        config: {},
        isDirty: false,
      }
    },
    created() {
    },
    mounted() {
      this.getFilters()
      EventBus.$on('FILTERS_UPDATED', payload => {
        this.scopes = { ...this.scopes, ...payload }
      });

      this.$watch('selected', (val) => {
        AxiosSource.cancel('Canceldd by User');
        let query = '';
        const keys = Object.keys(val);
        _.each(keys, (key, index) => {
          if (val[key].length === 0) return;
          query = index === 0 ? query.concat(key, ':') : query.concat(',', key, ':');
          _.each(val[key], (value, vIndex) => {
            query = vIndex === 0 ? query.concat(value) : query.concat('|', value);
          })
        });
        this.scopes = {...this.scopes, scopes: query, page: 1 }
        this.getFilters();
      });

      this.$watch('scopes', (val) => {
        const filtersBox = $('.filter-box__values');
        filtersBox.scrollTop(0);
      });
    },
    watch: {
      $route() {
        this.filters = {};
        this.selected = {};
        this.scopes = { ...this.dataFilters }
      }
    },
    methods: {
      onFilterSelected(key, {label}) {
        if (typeof this.selected[key] === 'undefined') {
          this.selected[key] = [];
        }
        if (typeof this.config.firstKey === 'undefined') {
          this.config = { ...this.config, firstKey: key };
        }
        this.config = { ...this.config, lastKey: key };
        if (this.selected[key].indexOf(label) === -1) {
          console.log('add ing key');
          this.selected = {
            ...this.selected, [key]: [...this.selected[key], label]
          };
        } else {
          let tempArray = [...this.selected[key]];
          if (tempArray.length > 1) {
            tempArray.splice(tempArray.indexOf(label), 1)
            this.selected = {
              ...this.selected, [key]: tempArray
            };
          } else {
            const { [key]: {}, ...filteredObject } = this.selected;
            this.selected = { ...filteredObject };
          }
        }
        if (Object.keys(this.selected).length === 0) {
          this.isDirty = false;
          const { firstKey, ...filteredConfig } = this.config;
          this.config = filteredConfig;
        }
        console.log(this.selected);
      },
      isFilterSelected(key, {label}) {
        // console.log('checking', key, label);
        if (typeof this.selected[key] === 'undefined') return false;
        // console.log('checking result', key, label, this.selected[key].indexOf(label));
        return this.selected[key].indexOf(label) !== -1;
      },
      async getFilters() {
        this.loading = { ...this.loading, ...{ isRefreshing: true } };
        const slug = this.$route.params.slug || this.$route.query.category;
        const {data} = await ProductRepository.getFilters(this.scopes).then(resp => resp.data);
        const category = await ProductCategoryRepository.getBySlug(slug).then((resp) => resp.data);
        const filterKeys = _.map(category.data.filters, 'name');
        let filters = {};
        if (Object.keys(this.filters).length === 0) {
          _.each(filterKeys, (key) => {
            filters[key] = {
              values: _.sortBy(_.uniqBy(_.map(data, (value) => {
                return {label: value[key], visible: true};
              }), 'label'), 'label').filter(el => typeof el.label !== 'undefined')
            }
          });
        } else {
          let newData = {};
          filters = this.filters;
          _.each(filterKeys, (key) => {
            if (typeof filters[key] !== 'undefined') {
              _.each(filters[key].values, ({label}, index) => {
                const fIndex = _.findIndex(data, (element) => element[key] === label);
                console.log(this.isDirty, this.config.firstKey, key);
                if (!this.isDirty && key !== this.config.firstKey) {
                  filters[key].values[index].visible = fIndex !== -1;
                } else if (this.isDirty && key !== this.config.lastKey) {
                  filters[key].values[index].visible = fIndex !== -1;
                }
                filters[key].values[index].priority = fIndex !== -1;
              });
              filters[key].values = _.sortBy(_.sortBy(filters[key].values, 'label'), (element) => -element.priority);
            }
          });
        }
        if (Object.keys(this.selected).length > 0) {
          this.isDirty = true;
        }
        this.filters = filters;
        // const filtersArray = _.uniq(_.map(data, 'brand')).filter(el => typeof el !== 'undefined');
        this.loading = { ...this.loading, ...{ isRefreshing: false } };
        // console.log(data, filterKeys, filtersArray);
      },
      getSpecLabelByKey(key) {
        if (typeof ProductCategorySpecs[this.dataFilters.category] !== 'undefined') {
          if (typeof ProductCategorySpecs[this.dataFilters.category].labels[key] !== 'undefined') {
            return ProductCategorySpecs[this.dataFilters.category].labels[key];
          }
          return key.replace("_", " ");
        } else {
          return key.replace("_", " ");
        }
      },
      onClearFilters(key) {
        const { [key]: {}, ...filteredObject } = this.selected;
        this.selected = { ...filteredObject };
        if (Object.keys(this.selected).length === 0) {
          this.isDirty = false;
          const { firstKey, ...filteredConfig } = this.config;
          this.config = filteredConfig;
        }
      },
      onClearAll() {
        const { firstKey, ...filteredConfig } = this.config;
        this.config = filteredConfig;
        this.isDirty = false;
        this.selected = {};
        this.$nextTick(() => this.$emit('updated', this.scopes));
      },
      onApplyFilters() {
        notify.success(this, { title: Lang.get('alerts.frontend.product-category.filters_updated'), text: false });
        this.$emit('updated', this.scopes);
      }
    }
  }
</script>
